var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @class
 * @extends AstronomicalObject
 * @name Planet
 * @desc 행성 클래스
 */
import { Vector3, MeshLambertMaterial, RingGeometry, Mesh, TextureLoader, DoubleSide } from 'three';
import { QUARTER_CIRCLE, DEG_TO_RAD } from 'src/constants';
import { AstronomicalObject } from 'src/lib/astronomical/AstronomicalObject';
import { AtmoSphere } from 'src/lib/astronomical/AtmoSphere';
import { OrbitManager } from 'src/lib/managers/Orbit.manager';
import { Tracer } from 'src/lib/helpers/Tracer';
import DimensionService from 'src/lib/services/Dimension.service';
var Planet = /** @class */ (function (_super) {
    __extends(Planet, _super);
    function Planet(data) {
        var _this = this;
        var astronomical = {
            id: data.id,
            name: data.name,
            mass: data.mass,
            radius: data.radius,
            material: data.material,
            sideralDay: data.sideralDay,
        };
        if (data.sideralDay) {
            astronomical.sideralDay = data.sideralDay;
        }
        _this = _super.call(this, astronomical) || this;
        _this.orbitManager = new OrbitManager(data.orbit);
        _this.angle = 0;
        _this.force = new Vector3();
        _this.movement = new Vector3();
        _this.prevPosition = new Vector3();
        _this.relPosition = new Vector3();
        _this.absVelocity = new Vector3();
        _this.relVelocity = new Vector3();
        var factor = 1.6;
        var orbitTraceLength = factor + Math.PI * DimensionService.getScaled(data.orbit.base.a);
        _this.traceManager = new Tracer(data.id, data.material.color, Math.pow(orbitTraceLength, 10));
        _this.hasTrace = false;
        if (data.atmosphere) {
            _this.atmospherePressure = data.atmosphere.atmospherePressure;
            _this.atmosphere = new AtmoSphere(data.atmosphere.components);
        }
        if (data.ring) {
            _this.ring = data.ring;
        }
        if (data.tilt) {
            _this.tilt = data.tilt;
        }
        _this.setPlanetBody();
        return _this;
    }
    Planet.prototype.setPlanetBody = function () {
        if (this.ring) {
            var innerSize = DimensionService.getScaled(this.ring.innerRadius);
            var outerSize = DimensionService.getScaled(this.ring.innerRadius);
            var segments = 20;
            var material = new MeshLambertMaterial({
                map: new TextureLoader().load(this.ring.map),
                transparent: true,
                side: DoubleSide
            });
            var geometry = new RingGeometry(outerSize, innerSize, segments);
            var mesh = new Mesh(geometry, material);
            mesh.rotation.x = -1 * QUARTER_CIRCLE;
            mesh.name = this.ringId;
            this.body.add(mesh);
        }
        var tilt = QUARTER_CIRCLE;
        if (this.tilt) {
            tilt -= (this.tilt * DEG_TO_RAD);
        }
        this.body.getObjectByName('mesh').rotation.x = tilt;
        this.root.add(this.body);
        this.root.add(this.traceManager.getTracer());
    };
    Planet.prototype.getPlanetRoot = function () {
        return this.root;
    };
    Planet.prototype.getPlanetBody = function () {
        return this.body;
    };
    Planet.prototype.setPositionByDate = function (date) {
        this.prevPosition = this.position.clone();
        this.position = this.orbitManager.calcPosition(date);
        this.compressedPos = this.getPosition();
        this.relPosition = this.position.clone();
        var x = this.compressedPos.x;
        var y = this.compressedPos.y;
        var z = this.compressedPos.z;
        this.body.position.set(x, y, z);
        if (this.hasTrace) {
            this.traceManager.updateTrace(this.body.position);
        }
    };
    Planet.prototype.getPosition = function () {
        var currentPosition = this.position.clone();
        return DimensionService.getScaledVector(currentPosition);
    };
    Planet.prototype.getScreenSizeRatio = function (camPos, fov) {
        var size = this.getObjectStageSize();
        var distance = this.getPosition().sub(camPos).length();
        var height = 2 * Math.tan((fov * DEG_TO_RAD) / 2) * distance;
        return size / height;
    };
    Planet.prototype.reset = function () {
        this.angle = 0;
        this.force = new Vector3();
        this.movement = new Vector3();
        this.prevPosition = new Vector3();
    };
    return Planet;
}(AstronomicalObject));
export { Planet };
